// - Headers
export default [
    {
        text: 'Folio',
        fieldType: 'computed',
        computed: ({ id }) => id,
        sortable: false, //campo que puede ser ordenado desde Maestros del Backend, se debe solicitar qué campo ordenar
    },
    {
        text: 'Cliente',
        fieldType: 'computed',
        computed: ({ sl_customer_id }) => sl_customer_id,
        sortable: false,
    },
    {
        text: 'Sucursal Cliente',
        //fieldType: 'text',
        sortable: false,
    },
    {
        text: 'Fecha creación',
        fieldType: 'computed',
        computed: ({ creation_date }) => {
            if (creation_date && creation_date !== null) {
                return creation_date.substr(0, 10)
            } else {
                return 'Sin definir'
            }
        },
        sortable: false,
    },
    {
        text: 'Plazo Pago',
        //fieldType: 'text',
        sortable: false,
    },
    {
        text: 'Estado',
        fieldType: 'computed',
        computed: ({ g_state_id }) => g_state_id,
        // sortable: false,
    },
    {
        text: 'Estado Documento',
    },
]
